import React from "react";
import { Row, Column } from "rla-components";

import { colors, spacing } from "../theme/theme";
import HeaderBlock from "../components/HeaderBlock";
import PageDetailContainer from "../components/PageDetailContainer";

export default class TermsPage extends React.Component {
    componentDidMount() {
        setTimeout(() => {
            window.dispatchEvent(new Event("load"));
        }, 0);
    }
    render() {
        const { transition } = this.props;
        return (
            <div style={transition && transition.style}>
                <PageDetailContainer>
                    <Row>
                        <Column>
                            <HeaderBlock
                                textAlign="left"
                                baseColor={colors.background}
                                fontSize={3}
                                padding={{
                                    top: 0.6,
                                    right: 0,
                                    bottom: 2.4,
                                    left: 0
                                }}
                            >
                                <span>Privacy </span>Policy
                            </HeaderBlock>
                        </Column>
                    </Row>

                    <Row>
                        <Column>
                            <p>RLA Group Ltd is committed to protecting your privacy</p>

                            <p>This Cookie and Privacy Policy applies to RLA Group Ltd (“RLA Group Ltd”, “we”, or “us”) owned and operated websites and subdomains (“sites”)</p>
                            <p>This policy sets out the basis on which any personal data we collect by us, or that you provide to us, will be processed by us, how the information is used, and how you can control the collection, correction and/or deletion of information. Please read the following carefully to understand our views and practices regarding your personal data and how we will treat it.</p>
                            <p>No personal data will be shared with anyone except as described in this Policy</p>
                            <p>For the purposes of this policy, the data controller is RLA Group Ltd, Parley Green Lane, Christchurch, Dorset BH23 6BB.</p>
                            <h3>1.	Information we collect</h3>
                            <p>(a) Our Service(s): We may collect personal identifiable information about you, such as name, address, phone number, email address or anything similar. We do not send any promotional emails, however we may send you information relating to services we can provide/offer you. You may opt out of receiving these emails at any time.</p>
                            <p>(b) Cookies and Tracking: Some technologies may be used by RLA Group Ltd on our sites such as cookies, marketing and analytics. These technologies may be used to analyse certain trends within our sites, gather information around page visits and /or demographic information, and to ensure the site performs in the best possible way. We may generate reports based on the results from the information gathered.
                            <br />We use cookies to remember users on some of our sites, user authentication and/or analytics. Users have the ability to control the use of cookies on our sites. If cookies are disabled, you may still use our sites but may have limited functionality.
                            <br />This website uses Google Analytics to track user activity across the website. To learn more about Google Analytics, please visit http://www.google.com/intl/en_uk/analytics/privacyoverview.html If you wish to disable Google analytics you may do so by disabling tracking cookies on the sites.</p>
                            <p>(c) Log Information: A log is automatically generated by our servers when someone browsers to our sites and all subsequent visits to the sites. An IP address is stored against a time stamp within these logs. There is no other personal data relating to you or your system stored in these logs</p>
                            <p>(d) Access and Retention of Collected Data: Anyone who has signed up to receive information from any of our sites may correct, amend or request deletion of any stored data by directing their query to privacy@rla.co.uk
                            <br />If we receive any request for the above we will respond within 72 business hours</p>
                            <p>Personal data will be retained for as long as required to provide our services, comply with legal obligations and /or resolve disputes</p>

                            <h3>2.	How we use your data</h3>
                            <p>The information we collect from our sites is used to provide marketing information on products and services offered by us, respond to any questions/queries and help improve our sites</p>

                            <h3>3.	How we share your information</h3>
                            <p>(a) Personal Data: RLA Group Ltd will not rent or sell any personal data provided by you to anyone else. We may store personal data on systems outside of our direct control (hosting providers, databases, email service providers).</p>

                            <p>(b) Non-Personal Data: We may share non personal data with third parties such as anonymous usage data, page clicks etc). This is to help us provide a better service and build on any further services we may offer in the future.</p>

                            <p>(c) Sharing your information: Your information will only be disclosed where required to do so by law. We will restrict any information provided where possible.</p>


                            <h3>4.	Storage and Processing</h3>

                            <p>Information collected by our sites will be stored within the EU. We may transfer information supplied by you, including personal information, to our affiliated entities.</p>

                            <h3>5.	How we protect your information</h3>

                            <p>Our main priority is to protect your privacy and data but we are unable to warrant the security of any third parties your data is passed on to. We have industry standard security practices in place to help protect your data but cannot guarantee the data may not be accessed, disclosed, altered or deleted due to a breach of these safeguards. All information accessed over our sites are encrypted using SSL (Secure Socket Layer) technology, although no method of transfer or encryption can be 100% secure we do implement best practices.
                            <br />If you have any concerns or questions about the security of our sites, please contact privacy@rla.co.uk.</p>

                            <h3>6.	Data breaches</h3>

                            <p>In the event of a compromise in personal data any affected data subject will be promptly notified in compliance with EU law.</p>

                            <h3>7.	Links to external websites and services</h3>

                            <p>We are not responsible for the security standards used by any websites/services out of our control that are linked to or from our sites. Any external site linked to or from ours will have their own Cookie and Privacy Policy, our policies will not apply.</p>

                            <h3>8.	Changes to our Cookie and Privacy Policy</h3>

                            <p>All changes made to our policies are effective as soon as they are posted on our sites. Any major changes to our policies will be communicated via email if required. Our latest policy will always be available on our sites.</p>

                            <h3>Cookies</h3>

                            <p>Cookies are very small text files that are stored on your computer when you visit some websites.
                            <br /> use cookies to make our website easier for you to use. You disable certain cookies on our site but this may impact the performance of the sites we provide.</p>

                        </Column>
                    </Row>
                </PageDetailContainer>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/privacy-policy.js